export default "__VITE_ASSET__fa2dfaef__"